module.exports = __webpack_public_path__ + "img/avris-logo-dark-no-tag.0c573f40.svg";